import axios from 'axios'
import _get from 'lodash/get'

export const WORK_FROM_HOME_UPDATE = 'WORK_FROM_HOME_UPDATE'
export const WORK_FROM_HOME_SAVE = 'WORK_FROM_HOME_SAVE'
export const WORK_FROM_HOME_SAVE_SUCCESS = 'WORK_FROM_HOME_SAVE_SUCCESS'
export const WORK_FROM_HOME_SAVE_ERROR = 'WORK_FROM_HOME_SAVE_ERROR'

export const requestWorkFromHomeAllowance = (selfAssessmentId) => (dispatch) => {
    dispatch(updateWorkFromHomeAllowance({ shouldFetch: false }))

    axios
        .get(`/workfromhomeallowance/${selfAssessmentId}`)
        .then((response) => {
            const payload = { ...response.data, fetchSuccessful: true }

            dispatch(updateWorkFromHomeAllowance(payload))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updateWorkFromHomeAllowance({ fetchSuccessful: true }))
            } else {
                dispatch(updateWorkFromHomeAllowance({ fetchSuccessful: false, shouldFetch: true }))
            }
        })
}

export const saveWorkFromHomeAllowance = () => (dispatch, getState) => {
    const { assessment, workFromHomeAllowance } = getState()

    axios
        .put(`/workfromhomeallowance/${assessment.id}`, {
            ...workFromHomeAllowance,
            selfAssessmentId: assessment.id,
        })
        .then((response) => {
            const payload = {
                ...response.data,
                goToNextQuestion: !workFromHomeAllowance.isAllowanceUpdate,
                goToNextAllowanceQuestion: workFromHomeAllowance.isAllowanceUpdate,
                isAllowanceUpdate: false,
            }

            dispatch(updateWorkFromHomeAllowance(payload))
        })
        .catch(() => {
            const payload = { ...workFromHomeAllowance, goToNextQuestion: false, goToNextAllowanceQuestion: false }
            dispatch(updateWorkFromHomeAllowance(payload))
        })
}

export const updateAndSaveWorkFromHomeAllowance = (workFromHomeAllowance) => (dispatch) => {
    dispatch(updateWorkFromHomeAllowance(workFromHomeAllowance))
    dispatch(saveWorkFromHomeAllowance())
}

export const updateWorkFromHomeAllowance = (payload) => ({
    type: WORK_FROM_HOME_UPDATE,
    payload,
})
